/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number, string,
    shape, object, bool,
} from 'prop-types';
import { withRouter } from 'react-router';
import Media from 'react-media';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { Drawer } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import { combineStyle } from '../../style/combineStyle';
import { deepObjectExtend } from '../../utils/object';
import { main as MainStyle } from '../../style/main';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import DesktopAccountHome from './DesktopAccountHome/DesktopAccountHome';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getProfileInfo } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getCurrentBrandId } from '../../state/ducks/Common/Common-Selectors';
import MobileAccountHome from './MobileAccountHome';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
    }),
    {
        drawer: {
            width: '300px',
        },
        listItemWrap: {
            paddingLeft: '32px',
        },
        accountHolderName: {
            padding: '15px 0px 5px 27px',
            textTransform: 'capitalize',
        },
        selectedUrl: {
            backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
        },
    },
);

class AccountHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    toggleDrawer = () => {
        this.setState((prevState) => ({ open: !prevState.open }));
    };

    render() {
        const {
            classes, userProfile, enableHeadingBreakdown,
            featureFlags, breakpoint, history, brandId, giftListV2,
        } = this.props;
        const { open } = this.state;
        const breakpointExpr = `(min-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;

        return (
            <>
                <GraphqlSeoHeadTags seoData={{
                    page_title: 'My Account',
                    location: { pathname: '/account' },
                }}
                />
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <>
                                <DesktopAccountHome featureFlags={featureFlags} history={history} userProfile={userProfile} />
                            </>
                        )
                            : (
                                <>
                                    {
                                        history.location.pathname === '/account'
                                            ? (
                                                <MobileAccountHome
                                                    brandId={brandId}
                                                    classes={classes}
                                                    userProfile={userProfile}
                                                    featureFlags={featureFlags}
                                                    isShowSlider={false}
                                                    history={history}
                                                />
                                            )
                                            : (
                                                <>
                                                    <Button
                                                        className={`back-arrow-button ${enableHeadingBreakdown ? classes.accountHolderName : ''}`}
                                                        onClick={this.toggleDrawer}
                                                    >
                                                        {giftListV2 ? <ArrowBackIosIcon /> : <ArrowBack />} {enableHeadingBreakdown && 'My Account'}
                                                    </Button>
                                                    <Drawer open={open} onClose={this.toggleDrawer} className={classes.main}>
                                                        <MobileAccountHome
                                                            brandId={brandId}
                                                            classes={classes}
                                                            userProfile={userProfile}
                                                            featureFlags={featureFlags}
                                                            isShowSlider
                                                            history={history}
                                                            toggleDrawer={this.toggleDrawer}
                                                        />
                                                    </Drawer>
                                                </>
                                            )
                                    }
                                </>
                            )

                    )}
                </Media>
            </>
        );
    }
}

AccountHome.defaultProps = {
    history: {},
    userProfile: {},
    featureFlags: {},
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
    brandId: '',
    giftListV2: false,
    enableHeadingBreakdown: false,
};

AccountHome.propTypes = {
    classes: object.isRequired,
    history: object,
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string, // some existing WCS users account don't have the XAttr attributes
        XAtt5: string,
    }),
    featureFlags: object,
    breakpoint: number,
    brandId: string,
    giftListV2: bool,
    enableHeadingBreakdown: bool,
};

const mapStateToProps = (state) => ({
    userProfile: getProfileInfo(state),
    brandId: getCurrentBrandId(state),
});

const enhance = compose(
    trackPage({
        type: 'myaccount',
        name: 'MyAccount',
        accountPage: true,
    }),
    withRouter,
    withStyles(styles, { withTheme: true }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    connect(mapStateToProps, null),
);
export default enhance(AccountHome);
